import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { Button, ChallengeCards, Section, Tabs } from '../..'
import { useChallenge, useUser } from '../../../context'
import { ChallengeStatus } from '../../../types'
import { CardsContainer } from '../../Cards/styles'

const ChallengesList = () => {
  const navigate = useNavigate()

  const { setOnEditionMode, onEditionMode, userRole } = useUser()
  const { challengeList } = useChallenge()
  const [filter, setFilter] = useState<string>('active')

  const filtered = challengeList.filter((c) => c.status === filter)

  const handleCreateChallenge = () => {
    if (!onEditionMode) {
      setOnEditionMode(true)
      navigate(`/desafios/crear-desafio`)
    }
  }

  return (
    <Section
      title="Desafios Diga-ah!"
      childrenClass="full-space-section"
      style={{ overflowY: 'scroll', paddingBottom: 0 }}
      ctaSection={{
        alignItems: 'center',
        cta: (
          <>
            {userRole === 'admin' && (
              <Button
                fontSize={14}
                fontWeight={600}
                onClick={handleCreateChallenge}
                label="Agregar desafio"
                className="light-blue"
              />
            )}
          </>
        ),
      }}
    >
      <Tabs
        id="status-tags"
        tabs={[
          ChallengeStatus.ACTIVE,
          ChallengeStatus.UPCOMING,
          ChallengeStatus.ENDED,
        ]}
        selectedValue={filter}
        handleTag={setFilter}
        isMenu={true}
      />

      <CardsContainer
        style={{
          maxHeight: 'calc(100vh - 440px)',
          flexWrap: 'wrap',
          flexDirection: 'row',
          gap: '10px',
          overflowY: 'scroll',
          paddingBottom: 20,
        }}
      >
        {filtered.map((ch) => (
          <ChallengeCards ch={ch} key={ch.id} />
        ))}
      </CardsContainer>
    </Section>
  )
}

export default ChallengesList
